import React from 'react';
import clsx from 'clsx';
import { formatMoney } from 'utils/storefront/format-resource';

const ProductPrice = ({ currentVariant }) => {
  if (!currentVariant) return null;
  const comparePrice = parseFloat(currentVariant.compareAtPrice.amount) > 0 ? currentVariant.compareAtPrice : null;

  return (
    <p className="body-2 mb-0">
      {comparePrice && <del className="text-grey-dark">{formatMoney(currentVariant.price)}</del>}
      <span className={clsx({ 'ml-1 text-error': comparePrice })}>
        {formatMoney(comparePrice || currentVariant.price)}
      </span>
    </p>
  );
};

export default ProductPrice;
